import ColorfulIcon from './colorful-icon';
export default ColorfulIcon;
